import styled from "@emotion/styled";
import colors from "src/utils/colors";

interface ItemLabel {
  bgColor?: string;
  noTextTransform?: boolean;
}

export default styled("div")<ItemLabel>`
  background: ${(props: ItemLabel) => props.bgColor || colors.darkGray};
  display: inline-block;
  color: ${colors.white};
  padding: 0 .75rem;
  border-radius: 10px;
  /* text-transform: ${(props: ItemLabel) =>
    props.noTextTransform ? "none" : "uppercase"}; */
  font-weight: bold;
  font-size: 0.75rem;
  margin: 0 0 0.27rem 0;
  height: 22px;
  line-height: 22px;
`;
